import React from 'react';

type ToggleInputProps = {
  toggled: boolean;
  handleToggle: () => void;
  name: string;
  informationText?: string;
  disabled?: boolean;
};

export const ToggleInput: React.FC<ToggleInputProps> = ({
  toggled,
  handleToggle,
  name,
  informationText,
  disabled = false,
}) => (
  <div className='flex items-center gap-2'>
    <button
        type='button'
        role='switch'
        aria-checked={toggled}
        aria-label={name}
        onClick={disabled ? undefined : handleToggle}
        disabled={disabled}
        className={`
        relative inline-flex h-4 w-8 shrink-0 items-center rounded-full transition-colors
       
        ${
          toggled
            ? 'bg-gradient-to-r from-emerald-700 to-emerald-500'
            : 'bg-gray-200'
        }
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
      `}
    >
      <span
          className={`
          inline-block h-3 w-3 transform rounded-full bg-white shadow-md transition-transform
          ${toggled ? 'translate-x-4' : 'translate-x-1'}
        `}
      />
    </button>

    { informationText && (
      <p className='text-xs font-medium leading-tight text-gray-600'>
        { informationText }
      </p>
    ) }
  </div>
);
